import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		config: {},
		projects: [],
		countdown: 0,
		sliders: [],
		galeryOpenend: false,
		galeryFile: ''
	},
	mutations: {
		setSettings (state, payload) {
			state.config = payload.config.data
			state.projects = payload.projects.data
		},
		setCountdown (state, t) {
			state.countdown = t
		},
		addSlider (state, s) {
			state.sliders.push(s)
		},
		toggleGalery (state) {
			state.galeryOpenend = !state.galeryOpenend
		},
		setGaleryFile (state, f) {
			state.galeryFile = f
		}
	},
	actions: {
		startCountdown ({ state, commit }) {
			commit('setCountdown', Date.now() + state.config.sliderAutoplayCountdown)

			const interval = setInterval(() => {
				const distance = state.countdown - Date.now()

				if (distance < 0) {
					commit('setCountdown', distance)
					clearInterval(interval)
				}
			}, 1000)
		},
		async getSettings ({ commit, dispatch }) {
			const payload = {}
			payload.config = await axios.get('./config.json')
			payload.projects = await axios.get('./projects.json')

			commit('setSettings', payload)
			dispatch('startCountdown')
		},
		addSlider ({ commit }, s) {
			commit('addSlider', s)
		},
		openGalery ({ commit }, file) {
			commit('toggleGalery')
			commit('setGaleryFile', file)
		},
		closeGalery ({ commit }) {
			commit('toggleGalery')
		},
		stopAutoplay ({ commit, state }) {
			state.sliders.forEach(slider => {
				slider.autoplay.stop()
			})
		},
		startAutoplay ({ commit, state }) {
			state.sliders.forEach(slider => {
				slider.autoplay.start()
			})
		}
	},
	getters: {
		countdownEnded: (state) => state.countdown < 0,
		galeryOpenend: (state) => state.galeryOpenend,
		galeryFile: (state) => state.galeryFile,
		config: (state) => state.config,
		projects: (state) => state.projects
	},
	modules: {
	}
})
